export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7629.18ab2a3a.jpg";